module.exports = __webpack_public_path__ + "static/media/icon-medicare-dental.6c6625db.svg";